/**
 * ログインユーザーのストアスライス
 */
import { createSlice } from '@reduxjs/toolkit';

const now = new Date();
export const loginUserSlice = createSlice({
  name: 'loginUser',
  initialState: {
    user: {
      id: '',
      add_message: 1,
      code: 0,
      response_s3_id: '',
      service_number: '',
      recipients: [
        {
          address: '',
          attach_media: 1,
          in_message: 1,
          incoming_notice: 1,
        },
      ],
      user_status: 0,
      api_keys: [
        {
          api_key: '',
          api_secret: '',
        },
      ],
      invitation_code: '',
      inviter: '',
      price: {
        base_charge: 0,
        ext_recording: 0,
        ext_response: 50,
      },
      response_text: '',
      response_voice_type: 0,
      stripe_id: '',
      access_token: '',
      user_name: '',
      user_number: '',
      receipt_name: '',
    },
    sessionExpired: now.getTime(),
  },
  reducers: {
    setUser: (state, action) => {
      state.user = action.payload;
    },
    setSessionExpired: (state, action) => {
      state.sessionExpired = action.payload;
    },
  },
});

export const { setUser, setSessionExpired } = loginUserSlice.actions;
export default loginUserSlice.reducer;
